// extracted by mini-css-extract-plugin
module.exports = {"container":"_3YQ4T","name":"_3dxbO","large":"Mg3oY","medium":"fdptF","profileInfo":"_2g5zc","link":"xjU44","profileLink":"_1ZxxE"};